<template>
  <div>
    <v-row dense align="center">
      <v-col cols="12" sm="9" class="text-truncate">
        <px-situacao-cotacao-icon :situacao="cotacao.situacao"/>
        {{ cotacao.identificador }}
      </v-col>
      <v-col cols="12" sm="3" class="text-right">
        <v-menu :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <px-cancelar-dialog
              texto-botao="Cancelar cotação"
              :titulo="getTitulo"
              :descricao="getDescricao"
              @cancelar-dialog="onClickCancelar"
              :disabled="!isAberta"/>
            <v-list-item :disabled="!isAberta"
                :to="linkEdicao">
              <v-list-item-icon>
                <v-icon>mdi-pencil</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Editar cotação</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="caption">
        <v-icon>mdi-domain</v-icon>
        {{ cotacao.company.pessoa.nome }} ({{ cotacao.company.pessoa.cnpj | cnpj }})
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="caption">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon class="mr-2">mdi-map-marker-multiple</v-icon>
            <span v-on="on">
              {{ cotacao.municipioColeta.nome }}
              ({{ cotacao.municipioColeta.estado.sigla }})
            </span>
          </template>
          <span>
            Município de coleta
          </span>
        </v-tooltip>
        <v-icon class="mx-5">mdi-arrow-right</v-icon>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ cotacao.municipioEntrega.nome }}
              ({{ cotacao.municipioEntrega.estado.sigla }})
            </span>
          </template>
          <span>
            Município de entrega
          </span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import CotacaoFreteService from '@/frete/cotacao/cotacao-frete-service';

export default {
  props: {
    cotacao: Object,
  },
  computed: {
    isAberta() {
      return SituacaoCotacao.keys.ABERTA.key === this.cotacao.situacao;
    },
    linkEdicao() {
      return `/edicao-cotacao-frete/${this.cotacao.id}`;
    },
    getTitulo() {
      return 'Cancelar cotação';
    },
    getDescricao() {
      return `A cotação "${this.cotacao.identificador}" será cancelada e não poderá mais receber respostas.<br/>Esta operação não pode ser desfeita.`;
    },
  },
  methods: {
    onClickCancelar(motivoRecusa) {
      CotacaoFreteService.cancelar(this.cotacao.id, { motivoRecusa })
        .then(() => {
          this.$toast('Cotação cancelada', { color: 'success' });
          this.emitUpdate();
        });
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
